import { memo, useState, useRef, useCallback } from "react";

import cc from "classcat";
import { useLocalization } from "@fluent/react";
import { IconButton, Tooltip } from "@narmi/design_system";

import { useSidebarContainer } from "../sidebar.hooks";

import styles from "./Sidebar.module.scss";

const ExpandCollapseButton = memo(function ExpandCollapseButton() {
  const { l10n } = useLocalization();
  const { isCollapsed, toggleCollapseClass } = useSidebarContainer();
  const [isTooltipOpen, setIsTooltipOpen] = useState(false);
  const hoverTimeoutRef = useRef<NodeJS.Timeout | null>(null);

  const handleMouseEnter = useCallback(() => {
    hoverTimeoutRef.current = setTimeout(() => {
      setIsTooltipOpen(true);
    }, 500);
  }, []);

  const handleMouseLeave = useCallback(() => {
    if (hoverTimeoutRef.current) {
      clearTimeout(hoverTimeoutRef.current);
      hoverTimeoutRef.current = null;
    }
    setIsTooltipOpen(false);
  }, []);

  return (
    <div onMouseEnter={handleMouseEnter} onMouseLeave={handleMouseLeave}>
      <Tooltip
        text={
          isCollapsed
            ? l10n.getString("button-expand-sidebar")
            : l10n.getString("button-collapse-sidebar")
        }
        isOpen={isTooltipOpen}
      >
        <div
          className={cc([
            styles["sidebar-expand-collapse-button"],
            isCollapsed && styles["sidebar-expand-collapse-button--collapsed"],
          ])}
        >
          <IconButton
            kind="action"
            label={
              isCollapsed
                ? l10n.getString("button-expand-sidebar")
                : l10n.getString("button-collapse-sidebar")
            }
            name="chevrons-left"
            onClick={toggleCollapseClass}
          />
        </div>
      </Tooltip>
    </div>
  );
});

export default ExpandCollapseButton;
